/* FuzzleFest theme scripts — no dependencies */
(function () {
  'use strict';
  const FF = window.FF || {};
  const routes = Object.assign({ cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart', root_url: '/' }, FF.routes || {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => { const cur = (window.FF && window.FF.currency) || 'USD'; try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format((cents || 0) / 100); } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); } };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Drawers (menu + cart) ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a');
    if (focusable) focusable.focus({ preventScroll: true });
  }
  function closeDrawer(el) {
    if (!el) return;
    el.hidden = true;
    document.documentElement.style.overflow = '';
  }
  const menu = $('#MenuDrawer');
  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { openDrawer(menu); b.setAttribute('aria-expanded', 'true'); }));
  $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { closeDrawer(menu); $$('[data-menu-open]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));

  const drawer = $('#CartDrawer');
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', (e) => { e.preventDefault(); refreshCart().then(() => openDrawer(drawer)); }));
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => closeDrawer(drawer)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(drawer); closeDrawer(menu); } });

  /* ---------- Cart ---------- */
  function updateShipping(cart) {
    const wrap = $('[data-ship-progress]');
    if (!wrap) return;
    const goal = Number(FF.freeShippingThreshold) || 0;
    const subtotal = cart ? cart.items_subtotal_price : 0;
    const text = $('[data-ship-text]', wrap);
    const fill = $('[data-ship-fill]', wrap);
    const pct = goal <= 0 ? 100 : Math.min(100, (subtotal / goal) * 100);
    const done = pct >= 100;
    text.textContent = done ? text.dataset.done : text.dataset.left.replace('[amount]', money(goal - subtotal));
    fill.style.width = (cart && cart.item_count === 0 && goal > 0 ? 0 : pct) + '%';
    wrap.classList.toggle('ship-progress--done', done);
  }

  function renderCart(cart) {
    const items = $('[data-cart-items]');
    const empty = $('[data-cart-empty]');
    const foot = $('[data-cart-foot]');
    const ship = $('[data-ship-progress]');
    const prot = FF.protection;
    const isProt = (it) => prot && it.product_id === prot.productId;
    const protLine = cart.items.find(isProt);
    const realItems = cart.items.filter((it) => !isProt(it));
    const realCount = realItems.reduce((a, it) => a + it.quantity, 0);
    /* Protection only makes sense with a katana in the cart */
    if (protLine && realCount === 0 && !renderCart.cleaning) {
      renderCart.cleaning = true;
      fetch(routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: protLine.key, quantity: 0 }) })
        .then((r) => r.json()).then((c) => { renderCart.cleaning = false; renderCart(c); }).catch(() => { renderCart.cleaning = false; });
    }
    $$('[data-cart-count]').forEach((c) => { c.textContent = realCount; c.hidden = realCount === 0; });
    const protInput = $('[data-ship-protect-input]');
    if (protInput) { protInput.checked = !!protLine; protInput.disabled = false; }
    if (!items) return;
    const isEmpty = realCount === 0;
    empty.hidden = !isEmpty;
    foot.hidden = isEmpty;
    if (ship) ship.hidden = isEmpty;
    items.innerHTML = cart.items.map((item, i) => {
      if (isProt(item)) return '';
      const variant = item.variant_title && !item.product_has_only_default_variant ? `<p class="drawer-line__variant">${esc(item.variant_title)}</p>` : '';
      const img = item.image ? `<img src="${esc(item.image)}${item.image.includes('?') ? '&' : '?'}width=200" alt="${esc(item.product_title)}" width="76" height="76" loading="lazy">` : '';
      const was = item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price)}</s>` : '';
      return `<div class="drawer-line">
        <a class="drawer-line__img" href="${esc(item.url)}">${img}</a>
        <div>
          <a class="drawer-line__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
          ${variant}
          <div class="drawer-line__qty">
            <button type="button" aria-label="Decrease quantity" data-line="${i + 1}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button type="button" aria-label="Increase quantity" data-line="${i + 1}" data-qty="${item.quantity + 1}">+</button>
          </div>
        </div>
        <div class="drawer-line__price">${was}${money(item.final_line_price)}
          <button class="drawer-line__remove" type="button" data-line="${i + 1}" data-qty="0">Remove</button>
        </div>
      </div>`;
    }).join('');
    const discount = cart.total_discount || 0;
    const discRow = $('[data-cart-discount-row]');
    discRow.hidden = discount <= 0;
    $('[data-cart-discount]').textContent = '−' + money(discount);
    $('[data-cart-total]').textContent = money(cart.total_price);
    updateShipping(cart);
  }

  function refreshCart() {
    return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json()).then((cart) => { renderCart(cart); return cart; })
      .catch(() => null);
  }

  if (drawer) {
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-ship-protect-input]');
      if (!input || !FF.protection) return;
      input.disabled = true;
      const headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
      const req = input.checked
        ? fetch(routes.cart_add_url + '.js', { method: 'POST', headers, body: JSON.stringify({ items: [{ id: FF.protection.variantId, quantity: 1 }] }) })
        : fetch(routes.cart_change_url + '.js', { method: 'POST', headers, body: JSON.stringify({ id: String(FF.protection.variantId), quantity: 0 }) });
      req.then(() => refreshCart()).catch(() => { input.disabled = false; });
    });
    drawer.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-line]');
      if (!btn) return;
      btn.disabled = true;
      fetch(routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Math.max(0, Number(btn.dataset.qty)) })
      }).then((r) => r.json()).then(renderCart).catch(() => { btn.disabled = false; });
    });
  }

  /* ---------- Countdown (only with a real sale end date) ---------- */
  const end = FF.saleEnd ? new Date(FF.saleEnd) : null;
  const timers = $$('[data-countdown]');
  if (end && !isNaN(end) && timers.length) {
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const ms = end - Date.now();
      if (ms <= 0) {
        timers.forEach((t) => { t.hidden = true; });
        $$('[data-countdown-fallback]').forEach((f) => { f.hidden = false; });
        clearInterval(iv); return;
      }
      const s = Math.floor(ms / 1000);
      const d = Math.floor(s / 86400);
      const parts = { d: pad(d), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
      const txt = (d > 0 ? d + 'd ' : '') + parts.h + ':' + parts.m + ':' + parts.s;
      timers.forEach((t) => {
        t.hidden = false;
        const v = t.querySelector('[data-countdown-value]'); if (v) v.textContent = txt;
        t.querySelectorAll('[data-cd]').forEach((el) => {
          const val = parts[el.dataset.cd];
          if (el.textContent !== val) { el.textContent = val; el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick'); }
        });
      });
    };
    const iv = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Product gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const thumbsBox = $('[data-gallery-thumbs]', g);
    const thumbs = $$('[data-thumb]', g);
    const slides = $$('.product-gallery__slide', g);
    let current = 0;
    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      const t = thumbs[i];
      if (t) thumbsBox.scrollTo({ left: t.offsetLeft - thumbsBox.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    };
    const go = (i) => {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' });
      setActive(i);
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    g.addEventListener('ff:gallery-go', (e) => { const i = Number(e.detail); if (i >= 0 && i < slides.length) go(i); });
    const prev = $('[data-gallery-prev]', g), next = $('[data-gallery-next]', g);
    if (prev) prev.addEventListener('click', () => go(current - 1));
    if (next) next.addEventListener('click', () => go(current + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const w = slides[0].getBoundingClientRect().width + 10;
        const i = Math.round(track.scrollLeft / w);
        if (i !== current) setActive(Math.min(i, slides.length - 1));
      });
    }, { passive: true });
  });

  /* ---------- Quantity offers + add to cart ---------- */
  $$('[data-product-section]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    let product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    const options = (product.options || []).map((o) => (typeof o === 'string' ? o : o.name));
    const variants = product.variants || [];
    const singleVariant = variants.length === 1 && options.length === 1 && /title/i.test(options[0]);
    const firstAvail = variants.find((v) => v.available) || variants[0];

    const valuesFor = (idx) => {
      const seen = [];
      variants.forEach((v) => { const val = v.options ? v.options[idx] : v['option' + (idx + 1)]; if (val != null && !seen.includes(val)) seen.push(val); });
      return seen;
    };
    const findVariant = (vals) => variants.find((v) => vals.every((val, i) => (v.options ? v.options[i] : v['option' + (i + 1)]) === val));

    const bundle = $('[data-bundle]', section);
    const form = $('[data-product-form]', section);
    const errorEl = form && $('[data-form-error]', form);
    let qty = 1;

    const buildRows = (tierEl, count) => {
      const box = $('[data-tier-items]', tierEl);
      if (!box || singleVariant) return;
      const label = `<p class="bundle__items-label">${esc(options.join(', '))}</p>`;
      let rows = '';
      for (let n = 1; n <= count; n++) {
        const selects = options.map((name, oi) => {
          const def = firstAvail ? (firstAvail.options ? firstAvail.options[oi] : firstAvail['option' + (oi + 1)]) : '';
          return `<select class="bundle__select" aria-label="${esc(name)} for item ${n}" data-opt="${oi}">${valuesFor(oi).map((v) => `<option value="${esc(v)}"${v === def ? ' selected' : ''}>${esc(v)}</option>`).join('')}</select>`;
        }).join('');
        rows += `<div class="bundle__row" data-item-row><span class="bundle__num">#${n}</span>${selects}</div>`;
      }
      box.innerHTML = label + rows;
    };

    const selectTier = (tierEl) => {
      if (!bundle) return;
      $$('.bundle__tier', bundle).forEach((t) => t.classList.toggle('is-selected', t === tierEl));
      qty = Number(tierEl.dataset.tier) || 1;
      const radio = $('input', tierEl);
      if (radio) radio.checked = true;
      if (!$('[data-item-row]', tierEl)) buildRows(tierEl, qty);
    };

    /* Show the chosen variant's photo (e.g. Green / Red) in the gallery */
    const gallery = $('[data-gallery]', section);
    section.addEventListener('change', (e) => {
      const row = e.target.closest('[data-item-row]');
      if (!row || !gallery) return;
      const v = findVariant($$('select', row).map((s) => s.value));
      const pos = v && v.featured_media && v.featured_media.position;
      if (pos) gallery.dispatchEvent(new CustomEvent('ff:gallery-go', { detail: pos - 1 }));
    });

    if (bundle) {
      const tiers = $$('.bundle__tier', bundle);
      tiers.forEach((t) => {
        t.addEventListener('click', (e) => { if (e.target.closest('select')) return; selectTier(t); });
        const r = $('input', t);
        if (r) r.addEventListener('change', () => selectTier(t));
      });
      const def = tiers.find((t) => t.classList.contains('is-selected')) || tiers[0];
      if (def) selectTier(def);
    }

    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('button[type=submit]', form);
      if (errorEl) errorEl.hidden = true;
      const counts = new Map();
      const selected = bundle && $('.bundle__tier.is-selected', bundle);
      const rows = selected ? $$('[data-item-row]', selected) : [];
      if (rows.length && !singleVariant) {
        for (const row of rows) {
          const vals = $$('select', row).map((s) => s.value);
          const v = findVariant(vals);
          if (!v || !v.available) {
            if (errorEl) { errorEl.textContent = (vals.join(' / ')) + ' is sold out. Please choose another option.'; errorEl.hidden = false; }
            return;
          }
          counts.set(v.id, (counts.get(v.id) || 0) + 1);
        }
      } else {
        counts.set(Number($('input[name=id]', form).value) || (firstAvail && firstAvail.id), qty);
      }
      const items = Array.from(counts, ([id, quantity]) => ({ id, quantity }));
      const label = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      /* A bundle replaces this product's quantity in the cart instead of stacking on top of it,
         so "Buy 2" always ends up as exactly 2 in the cart. */
      const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
      fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          const updates = {};
          (cart.items || []).forEach((it) => { if (it.product_id === product.id) updates[it.key] = 0; });
          if (!Object.keys(updates).length) return null;
          return fetch(routes.root_url.replace(/\/$/, '') + '/cart/update.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ updates }) });
        })
        .then(() => fetch(routes.cart_add_url + '.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({ items })
        }))
        .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
        .then(({ ok, j }) => {
          if (!ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return refreshCart();
        })
        .then(() => openDrawer(drawer))
        .catch((err) => { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
        .finally(() => { btn.disabled = false; btn.textContent = label; });
    });
  });

  /* ---------- Review slider (auto-rotating, with dots) ---------- */
  $$('[data-review-slider]').forEach((s) => {
    const track = $('.review-slider__track', s);
    const slides = $$('.review-item', s);
    const dots = $('[data-review-dots]', s);
    if (slides.length < 2) return;
    let i = 0, timer;
    dots.innerHTML = slides.map((_, n) => `<button type="button" aria-label="Review ${n + 1}"${n === 0 ? ' class="is-active"' : ''}></button>`).join('');
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      track.style.transform = `translateX(-${i * 100}%)`;
      $$('button', dots).forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 5000); };
    $$('button', dots).forEach((d, k) => d.addEventListener('click', () => { show(k); auto(); }));
    auto();
  });

  /* ---------- Image slider arrows ---------- */
  $$('[data-image-slider]').forEach((s) => {
    const track = $('[data-slider-track]', s);
    const step = () => { const sl = $('.image-slider__slide', track); return sl ? sl.getBoundingClientRect().width + 20 : track.clientWidth; };
    const prev = $('[data-slider-prev]', s), next = $('[data-slider-next]', s);
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step(), behavior: 'smooth' });
    });
  });

  /* ---------- Delivery timeline (business-day estimates) ---------- */
  $$('[data-delivery-timeline]').forEach((el) => {
    const addBusinessDays = (date, n) => {
      const d = new Date(date);
      let added = 0;
      while (added < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) added++; }
      return d;
    };
    const ord = (n) => { const s = ['th', 'st', 'nd', 'rd'], v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); };
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short' }) + ' ' + ord(d.getDate());
    const range = (a, b) => { const x = fmt(a), y = fmt(b); return x === y ? x : x + ' - ' + y; };
    const today = new Date();
    const n = (k) => Math.max(0, parseInt(el.dataset[k], 10) || 0);
    const set = (sel, txt) => { const t = el.querySelector(sel); if (t) t.textContent = txt; };
    set('[data-dt-ordered]', fmt(today));
    set('[data-dt-ready]', range(addBusinessDays(today, n('readyMin')), addBusinessDays(today, n('readyMax'))));
    set('[data-dt-delivered]', range(addBusinessDays(today, n('deliveryMin')), addBusinessDays(today, n('deliveryMax'))));
  });

  refreshCart();
})();

/* Currency dropdown: open/close, then submit the chosen country */
(() => {
  const root = document.querySelector('[data-currency-switcher]');
  if (!root) return;
  const toggle = root.querySelector('[data-currency-toggle]');
  const menu = root.querySelector('.currency-switcher__menu');
  const input = root.querySelector('[data-country-input]');
  const setOpen = (open) => { menu.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); };
  toggle.addEventListener('click', (e) => { e.stopPropagation(); setOpen(menu.hidden); });
  menu.addEventListener('click', (e) => {
    const opt = e.target.closest('.currency-switcher__option');
    if (!opt) return;
    if (opt.classList.contains('is-active')) { e.preventDefault(); setOpen(false); return; }
    input.value = opt.dataset.country;
  });
  document.addEventListener('click', (e) => { if (!root.contains(e.target)) setOpen(false); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) { setOpen(false); toggle.focus(); } });
})();
